var map = {
	"./AddContact.png": 9733,
	"./All mail.png": 6597,
	"./All mailActive.png": 7935,
	"./Archive.png": 5710,
	"./ArchiveActive.png": 8554,
	"./Arrow.png": 9542,
	"./AttachmentIcon.png": 978,
	"./Blue/Archive.png": 936,
	"./Blue/MailboxInverted.png": 36,
	"./Blue/Star.png": 9904,
	"./Blue/StarFilled.png": 7574,
	"./Blue/Trash.png": 9654,
	"./Calendar.png": 4761,
	"./CloseIcon.png": 9862,
	"./Contacts.png": 7873,
	"./ConversationImage.png": 7592,
	"./ConversationsIcon.png": 9029,
	"./DeleteIcon.png": 1133,
	"./Drafts.png": 2014,
	"./DraftsActive.png": 5260,
	"./EllipsisIcon.png": 4299,
	"./ExpandIcon.png": 3786,
	"./External.png": 9652,
	"./ForwardIcon.png": 4993,
	"./Globe.png": 7551,
	"./Header/Bucket.png": 6982,
	"./Header/Folder.png": 1365,
	"./Header/Inbox.png": 7313,
	"./Header/Label.png": 893,
	"./Header/Spam.png": 9649,
	"./Header/Trash.png": 1555,
	"./Hover/All mail.png": 4756,
	"./Hover/Archive.png": 7541,
	"./Hover/Bucket.png": 799,
	"./Hover/Delete.png": 5329,
	"./Hover/Drafts.png": 9684,
	"./Hover/Fire.png": 9600,
	"./Hover/Folder.png": 8226,
	"./Hover/Inbox.png": 3623,
	"./Hover/Label.png": 6680,
	"./Hover/Mailbox.png": 4709,
	"./Hover/Sent.png": 1997,
	"./Hover/Spam.png": 6658,
	"./Hover/Starred.png": 1066,
	"./Hover/Trash.png": 6592,
	"./Inbox.png": 4948,
	"./InboxActive.png": 6222,
	"./LockIcon.png": 4103,
	"./Logo.png": 6148,
	"./MinimizeIcon.png": 7310,
	"./OpenMailbox.png": 4067,
	"./Proton.png": 7130,
	"./ProtonCalendar.png": 514,
	"./ProtonDrive.png": 708,
	"./ProtonMail.png": 6796,
	"./ProtonVPN.png": 8639,
	"./Refresh.png": 2058,
	"./ReplyAllIcon.png": 7139,
	"./ReplyIcon.png": 9682,
	"./SearchIcon.png": 5870,
	"./Sent.png": 9391,
	"./SentActive.png": 8625,
	"./Settings.png": 791,
	"./Spam.png": 6011,
	"./SpamActive.png": 7119,
	"./StarFilled.png": 5059,
	"./StarIcon.png": 6819,
	"./Starred.png": 1815,
	"./StarredActive.png": 4490,
	"./TextEditor.png": 5423,
	"./Trash.png": 4674,
	"./TrashActive.png": 2725,
	"./Upgrade.png": 705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;